import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

export function Tip({ children, content, side = "top", delayDuration = 300, className = "" }) {
  if (!content) return children;
  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={className}>
        <p>{content}</p>
      </TooltipContent>
    </Tooltip>
  );
}

export { TooltipProvider };
